var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCushion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2191_1143)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 120L27.9724 117.021L12.0621 107.938L2.64828 91.6138L0 60L2.66897 27.9517L12.0621 12.0621L28.3862 2.64828L60 0L92.0483 2.66897L107.938 12.0621L117.331 27.9517L120 60L117.228 92.0483L107.938 107.938L91.8207 117.145L60 120ZM28.7793 115.138L60 117.931L91.3241 115.097L106.366 106.407L115.262 91.1793L117.931 60L115.345 28.5931L106.448 13.5517L91.4069 4.65517L60 2.06897L28.9655 4.69655L13.5517 13.5517L4.65517 28.5931L2.06897 60L4.65517 91.2207L13.5517 106.448L28.7793 115.138Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9586 107.69H12.3103V87.0621H13.3241V106.676H32.9586V107.69Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.689 107.69H87.2473V106.676H106.675V87.0622H107.689V107.69Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.689 32.5447H106.675V13.324H87.2473V12.3102H107.689V32.5447Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3241 32.7517H12.3103V12.3103H32.9586V13.3241H13.3241V32.7517Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0001 27.4138L32.7104 13.2621L33.1863 12.3517L60.0001 26.2759L87.0208 12.3517L87.4967 13.2621L60.0001 27.4138Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.493 59.7866L106.747 86.8512L107.677 87.2548L119.423 60.1902L118.493 59.7866Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.208 119.462L59.7942 118.51L86.7528 106.862V87.0622L92.6287 60.0002L86.7528 32.8553V13.1381L59.7942 1.46912L60.208 0.538086L87.7666 12.476V32.7519L93.6838 60.0002L87.7459 87.1657L87.7666 107.524L60.208 119.462Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4407 108.041V87.062L26.5234 60L26.5441 59.8965L32.4614 32.6276L32.4407 12.4758L59.7924 0.558594L60.2062 1.46894L33.4545 13.1379V32.7517L27.5579 60L33.4338 86.9379L33.4545 106.345L59.9993 92.3793L87.4959 106.738L87.02 107.648L59.9993 93.5172L32.4407 108.041Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1552 106.72L32.75 107.649L59.7941 119.442L60.1993 118.513L33.1552 106.72Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.641 32.572L106.711 32.9746L118.502 60.2224L119.433 59.8198L107.641 32.572Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0011 93.476L32.8356 87.5588H12.4149L0.539062 60.207L1.4701 59.7932L12.8494 85.8829L26.4839 60.0001L12.0011 32.2346H32.9391L60.0011 26.3174H60.1046L87.3735 32.2139H108.063L93.7253 60.0001L108.022 87.5588H87.3322L60.0011 93.476ZM13.6563 86.545H32.9391L60.0011 92.4415L87.146 86.5657H106.346L92.5873 60.0001L92.7115 59.7726L106.367 33.2484H87.2494L60.0011 27.3726L33.1046 33.2484H13.6563L27.6218 60.0001L13.6563 86.545Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.332 32.549L0.559814 59.805L1.49051 60.207L13.2627 32.951L12.332 32.549Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.88019 27.8147L3.43481 28.7254L12.5792 33.1973L13.0246 32.2866L3.88019 27.8147Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9317 3.42673L28.021 3.8721L32.4929 13.0165L33.4036 12.5712L28.9317 3.42673Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2451 3.4464L86.7732 12.5908L87.6839 13.0362L92.1558 3.89177L91.2451 3.4464Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.421 33.2069L106.966 32.2965L116.131 27.8069L116.566 28.7172L107.421 33.2069Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.131 91.9862L106.966 87.5172L107.421 86.5862L116.566 91.0759L116.131 91.9862Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2838 116.359L86.7942 107.421L87.7045 106.965L92.1942 115.903L91.2838 116.359Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9233 116.359L28.0129 115.903L32.5026 106.965L33.3922 107.421L28.9233 116.359Z",
    fill: "#81D8D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5714 86.6035L3.427 91.0754L3.87238 91.9861L13.0168 87.5142L12.5714 86.6035Z",
    fill: "#81D8D0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2191_1143"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCushion);
export default __webpack_public_path__ + "static/media/Cushion.499cb0d8c730a2f53e2614fb9a31439c.svg";
export { ForwardRef as ReactComponent };